// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar {
  min-width: 200px;
  max-width: 200px;
  min-height: 100vh;
  color: #fff;
  transition: all 0.3s;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.5;
}

#sidebar.hidden {
  margin-left: -200px;
}

a[data-toggle='collapse'] {
  position: relative;
}

@media (max-width: 575px) {
  #sidebar {
    margin-left: -200px;
  }
  #sidebar.hidden {
    margin-left: 0;
  }
}

#sidebar .sidebar-header {
  padding: 20px;
}

#sidebar ul li a {
  padding: 15px;
  display: block;
  width: 100%;
}

hr {
  border-top: 1px solid #fff;
  margin-top: 0;
}
/**tabbar left navigation starts**/
.leftNav {
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow-y: auto;
  top: 0;
  left: 0;
  min-width: 170px;
  max-width: 250px;
  z-index: 999;
  width: 250px;
  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);
}
.leftNavContent {
  width: 100%;
  /* height: 100%; */
  background-color: #fff;
  position: relative;
  z-index: 9;
  display: flex;
  flex-direction: column;
}
.leftNavContent .profileContent {
  padding: 1.95rem 1rem 0.15rem;
  min-height: 8rem;
  width: 100%;
  background: rgb(16, 4, 208);
  background: linear-gradient(
    90deg,
    rgba(16, 4, 208, 1) 0%,
    rgba(13, 113, 232, 1) 35%,
    rgba(67, 216, 246, 1) 100%
  );
  color: #ffffff;
}
.leftNavContent .profileContent > span {
  background: rgb(51 102 255 / 70%);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 8px;
  color: #fff;
  font-size: 1.6rem;
}
.leftNavContent .profileContent > span img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.leftNavContent .profileContent > h6 {
  margin: 0;
  font-size: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.leftNavContent .menubar {
  width: 100%;
  height: calc(100% - 32rem);
}
.leftNav ul.lnUl {
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}
.leftNav ul.lnUl li {
  display: block;
  padding: 0 5px 0 0;
}
.leftNav ul.lnUl li > a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #222b45;
  border-bottom: 1px solid #edf1f7;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  font-weight: normal;
  padding: 14px 25px 14px 15px;
}
.leftNav ul.lnUl li:last-child > a {
  border-bottom-color: transparent;
}
.leftNav ul.lnUl li:hover > a,
.leftNav ul.lnUl li:hover > a > i {
  color: #36f;
}
.leftNav ul.lnUl li > a.active,
.leftNav ul.lnUl li > a.active > i {
  color: #36f;
}
.leftNav ul.lnUl li > a.active::before {
  content: '';
  width: 3px;
  height: 100%;
  background-color: #7f8dff;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
}
.leftNav ul.lnUl li > a > span {
  display: block;
  font-size: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: normal;
}
.leftNav ul.lnUl li > a > i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  margin-right: 10px;
  width: 20px;
  color: #828c9f;
}
.leftNav ul.lnUl > li:hover ul {
  background-color: rgba(0, 0, 0, 0.01);
}
.leftNav ul.lnUl li.hasSubMenu > a:after {
  content: '\\e908';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'icomoon';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}
.leftNav ul.lnUl li.hasSubMenu > a.activeTab:after {
  transform: translateY(-50%) rotate(90deg);
}
.leftNav ul.lnUl > li.hasSubMenu ul {
  display: none;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li {
  padding: 0;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li > a {
  padding-left: 30px;
  color: #617d95;
}
.leftNav ul.lnUl > li.hasSubMenu > ul li > a:hover {
  color: #36f;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul {
  position: fixed;
  top: 400px;
  left: 235px;
  z-index: 99;
  box-shadow: 0 7px 18px -8px #000;
  -webkit-box-shadow: 0 7px 18px -8px #000;
  -moz-box-shadow: 0 7px 18px -8px #000;
  background-color: #fff;
  overflow: hidden;
  overflow-y: auto;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {
  color: #153d77;
}
.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul.active {
  display: block;
  background-color: #f2f2f2;
}
.menuClosed .leftNav {
  margin-left: -250px;
}
.menuClosed .leftNav {
  min-width: 10px !important;
  width: 60px !important;
  overflow-x: hidden;
  transition: width 0.3s ease;
}
.leftNavActionbar {
  height: 45px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.leftNavActionbar a {
  background-color: #8f9bb3;
  color: #fff;
  padding: 10px 15px;
  height: 45px;
  display: flex;
  width: 100%;
}
/**tabbar left navigation ends**/

@media (max-width: 767px) {
  .leftNav {
    position: fixed;
    /* top: 50px; */
    top: auto;
    z-index: 98;
    height: calc(100% - 50px);
  }
}
.btnToggleBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
  font-size: 0.6rem;
}

.profileContent .block > h4 {
  border-bottom: none !important;
  padding-bottom: 0px !important;
}

.leftNav .userSetting ul.lnUl li > a {
  border-bottom: 1px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);
}

.signout {
  background: linear-gradient(to left, #1bd2f7, #c0eef7);
}
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .leftNav {
    width: 170px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/home/menu-home/menu-home.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA,kCAAkC;AAClC;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B;;;;;GAKC;EACD,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA,gCAAgC;;AAEhC;EACE;IACE,eAAe;IACf,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,sDAAsD;AACxD;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["#sidebar {\n  min-width: 200px;\n  max-width: 200px;\n  min-height: 100vh;\n  color: #fff;\n  transition: all 0.3s;\n  font-weight: 300;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n#sidebar.hidden {\n  margin-left: -200px;\n}\n\na[data-toggle='collapse'] {\n  position: relative;\n}\n\n@media (max-width: 575px) {\n  #sidebar {\n    margin-left: -200px;\n  }\n  #sidebar.hidden {\n    margin-left: 0;\n  }\n}\n\n#sidebar .sidebar-header {\n  padding: 20px;\n}\n\n#sidebar ul li a {\n  padding: 15px;\n  display: block;\n  width: 100%;\n}\n\nhr {\n  border-top: 1px solid #fff;\n  margin-top: 0;\n}\n/**tabbar left navigation starts**/\n.leftNav {\n  height: 100%;\n  background-color: #fff;\n  position: relative;\n  overflow-y: auto;\n  top: 0;\n  left: 0;\n  min-width: 170px;\n  max-width: 250px;\n  z-index: 999;\n  width: 250px;\n  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);\n}\n.leftNavContent {\n  width: 100%;\n  /* height: 100%; */\n  background-color: #fff;\n  position: relative;\n  z-index: 9;\n  display: flex;\n  flex-direction: column;\n}\n.leftNavContent .profileContent {\n  padding: 1.95rem 1rem 0.15rem;\n  min-height: 8rem;\n  width: 100%;\n  background: rgb(16, 4, 208);\n  background: linear-gradient(\n    90deg,\n    rgba(16, 4, 208, 1) 0%,\n    rgba(13, 113, 232, 1) 35%,\n    rgba(67, 216, 246, 1) 100%\n  );\n  color: #ffffff;\n}\n.leftNavContent .profileContent > span {\n  background: rgb(51 102 255 / 70%);\n  width: 50px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  margin-bottom: 8px;\n  color: #fff;\n  font-size: 1.6rem;\n}\n.leftNavContent .profileContent > span img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.leftNavContent .profileContent > h6 {\n  margin: 0;\n  font-size: 0.9rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.leftNavContent .menubar {\n  width: 100%;\n  height: calc(100% - 32rem);\n}\n.leftNav ul.lnUl {\n  height: 100%;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n.leftNav ul.lnUl li {\n  display: block;\n  padding: 0 5px 0 0;\n}\n.leftNav ul.lnUl li > a {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: #222b45;\n  border-bottom: 1px solid #edf1f7;\n  position: relative;\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\n  font-weight: normal;\n  padding: 14px 25px 14px 15px;\n}\n.leftNav ul.lnUl li:last-child > a {\n  border-bottom-color: transparent;\n}\n.leftNav ul.lnUl li:hover > a,\n.leftNav ul.lnUl li:hover > a > i {\n  color: #36f;\n}\n.leftNav ul.lnUl li > a.active,\n.leftNav ul.lnUl li > a.active > i {\n  color: #36f;\n}\n.leftNav ul.lnUl li > a.active::before {\n  content: '';\n  width: 3px;\n  height: 100%;\n  background-color: #7f8dff;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.leftNav ul.lnUl li > a > span {\n  display: block;\n  font-size: 0.9rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: normal;\n}\n.leftNav ul.lnUl li > a > i {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  margin-right: 10px;\n  width: 20px;\n  color: #828c9f;\n}\n.leftNav ul.lnUl > li:hover ul {\n  background-color: rgba(0, 0, 0, 0.01);\n}\n.leftNav ul.lnUl li.hasSubMenu > a:after {\n  content: '\\e908';\n  display: inline-block;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n  font-family: 'icomoon';\n  font-weight: normal;\n  font-size: 0.7rem;\n  transition: all 0.2s ease-out;\n}\n.leftNav ul.lnUl li.hasSubMenu > a.activeTab:after {\n  transform: translateY(-50%) rotate(90deg);\n}\n.leftNav ul.lnUl > li.hasSubMenu ul {\n  display: none;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul li {\n  padding: 0;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul li > a {\n  padding-left: 30px;\n  color: #617d95;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul li > a:hover {\n  color: #36f;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul {\n  position: fixed;\n  top: 400px;\n  left: 235px;\n  z-index: 99;\n  box-shadow: 0 7px 18px -8px #000;\n  -webkit-box-shadow: 0 7px 18px -8px #000;\n  -moz-box-shadow: 0 7px 18px -8px #000;\n  background-color: #fff;\n  overflow: hidden;\n  overflow-y: auto;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {\n  color: #153d77;\n}\n.leftNav ul.lnUl > li.hasSubMenu > ul > li.hasSubMenu > ul.active {\n  display: block;\n  background-color: #f2f2f2;\n}\n.menuClosed .leftNav {\n  margin-left: -250px;\n}\n.menuClosed .leftNav {\n  min-width: 10px !important;\n  width: 60px !important;\n  overflow-x: hidden;\n  transition: width 0.3s ease;\n}\n.leftNavActionbar {\n  height: 45px;\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n}\n.leftNavActionbar a {\n  background-color: #8f9bb3;\n  color: #fff;\n  padding: 10px 15px;\n  height: 45px;\n  display: flex;\n  width: 100%;\n}\n/**tabbar left navigation ends**/\n\n@media (max-width: 767px) {\n  .leftNav {\n    position: fixed;\n    /* top: 50px; */\n    top: auto;\n    z-index: 98;\n    height: calc(100% - 50px);\n  }\n}\n.btnToggleBlock {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 10px;\n  color: #ffffff;\n  cursor: pointer;\n  z-index: 2;\n  font-size: 0.6rem;\n}\n\n.profileContent .block > h4 {\n  border-bottom: none !important;\n  padding-bottom: 0px !important;\n}\n\n.leftNav .userSetting ul.lnUl li > a {\n  border-bottom: 1px solid;\n  border-image-slice: 1;\n  border-width: 1px;\n  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);\n}\n\n.signout {\n  background: linear-gradient(to left, #1bd2f7, #c0eef7);\n}\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\n  .leftNav {\n    width: 170px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
